import { DateShortcut, getShortcutName } from "@/SharedComponents/Filters";
import { format, parseISO } from "date-fns";
import { useI18n } from "vue-i18n";

export function formatDateRange({ range, shortcutId, label }) {
    const { t } = useI18n();

    if (!range) {
        return "";
    }

    if (shortcutId === DateShortcut.CUSTOM) {
        if (range.start && range.end) {
            const startDate = format(parseDate(range.start), "dd/MM/yy");
            const endDate = format(parseDate(range.end), "dd/MM/yy");
            return startDate === endDate
                ? startDate
                : `${startDate} - ${endDate}`;
        } else {
            return t("components.inputs.datepicker.shortcuts.overdue");
        }
    }

    return label || getShortcutName(shortcutId);
}

function parseDate(dateString) {
    try {
        const isoDate = parseISO(dateString);
        if (!isNaN(isoDate)) {
            return isoDate;
        }
    } catch (error) {
        // Do nothing
    }

    const fallbackDate = new Date(dateString);
    if (!isNaN(fallbackDate)) {
        return fallbackDate;
    }

    return null;
}
